// react and js
import { React, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

// mui
import { Box, ClickAwayListener, Paper, Popper, Typography } from "@mui/material";
import TranslateIcon from "@mui/icons-material/Translate";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

// components

// hooks

// i18n
import { LANGUAGES, buildLanguageSwitchUrl } from "../i18n/languages";

// layouts

// pages

// theme

// utils

// widgets

// ----------------------------------------------------------------------
// Code
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Properties
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Main element export(s)
// ----------------------------------------------------------------------
export default function LanguageSelector() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const [pinned, setPinned] = useState(false);
  const anchorRef = useRef(null);

  const currentLang = LANGUAGES.find((l) => l.code === i18n.language) || LANGUAGES[0];

  const handleClose = () => {
    setOpen(false);
    setPinned(false);
  };

  const handleSelect = (code) => {
    handleClose();
    if (code === i18n.language) return;
    // Full reload so the BrowserRouter basename re-detects from the new URL.
    const nextUrl = buildLanguageSwitchUrl(
      code,
      window.location.pathname,
      window.location.search,
      window.location.hash
    );
    window.location.assign(nextUrl || "/");
  };

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <Box
        ref={anchorRef}
        onMouseEnter={() => {
          if (!open) setOpen(true);
        }}
        onMouseLeave={() => {
          if (!pinned) setOpen(false);
        }}
        sx={{ position: "relative" }}
      >
        <Box
          onClick={() => {
            if (pinned) {
              setOpen(false);
              setPinned(false);
            } else {
              setOpen(true);
              setPinned(true);
            }
          }}
          sx={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            gap: 0.5,
            px: 1,
            py: 0.5,
            color: "#555",
            "&:hover": { color: "#4CB833" },
          }}
        >
          <TranslateIcon sx={{ fontSize: 18, color: "inherit" }} />
          <Typography sx={{ fontSize: "13px", color: "inherit" }}>
            {currentLang.nativeName}
          </Typography>
          <KeyboardArrowDownIcon
            sx={{
              fontSize: 16,
              color: "inherit",
              transition: "transform 0.25s ease",
              transform: open ? "rotate(180deg)" : "rotate(0deg)",
            }}
          />
        </Box>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          placement="bottom-end"
          sx={{ zIndex: 1300 }}
        >
          <Paper
            sx={{
              maxHeight: 400,
              width: 130,
              borderRadius: "8px",
              mt: 0.5,
              py: 0.5,
              overflowY: "auto",
              opacity: open ? 1 : 0,
              transform: open ? "translateY(0)" : "translateY(-4px)",
              transition: "opacity 0.2s ease, transform 0.2s ease",
            }}
          >
            {LANGUAGES.map((l) => (
              <Box
                key={l.code}
                onClick={() => handleSelect(l.code)}
                sx={{
                  fontSize: "14px",
                  py: 0.75,
                  px: 2,
                  cursor: "pointer",
                  color: l.code === i18n.language ? "#4CB833" : "#333",
                  "&:hover": { color: "#4CB833" },
                }}
              >
                {l.nativeName}
              </Box>
            ))}
          </Paper>
        </Popper>
      </Box>
    </ClickAwayListener>
  );
}
